export default require("./node_modules/element-plus/lib/locale/lang/en.js");